import axios from 'axios';
import { loginreq, req } from './axiosFun';

export const findAccoutMoneySum = (params) => { return req("get", "/api/haomeiIndex/findAccoutMoneySum", params) };

export const findEnergyTotalByYearDate = (params) => { return req("get", "/api/haomeiIndex/findEnergyTotalByYearDate", params) };

export const getAllUnUpdateMeterInfoTotal = (params) => { return req("get", "/api/haomeiIndex/getAllUnUpdateMeterInfoTotal", params) };

export const findAppletUserSum = (params) => { return req("get", "/api/haomeiIndex/findAppletUserSum", params) };

export const findAccoutMoneyTotal = (params) => { return req("get", "/api/haomeiIndex/findAccoutMoneyTotal", params) };

export const findFacilitySum = (params) => { return req("get", "/api/haomeiIndex/findFacilitySum", params) };

export const getEnergyByEnergyType = (params) => { return req("get", "/api/haomeiIndex/getEnergyByEnergyType", params) };

export const EnergyRecordYtListNew = (params) => { return req("get", "/api/haomeiIndex/EnergyRecordYtListNew", params) };

export const findEnergyTotalByMonthDate = (params) => { return req("get", "/api/haomeiIndex/findEnergyTotalByMonthDate", params) };

export const getAllProviceCity = (params) => { return req("get", "/api/provinceCity/getAllProviceCity", params) };

export const addProvinceUserTotal = (params) => { return req("post", "/api/provinceUserTotal/addProvinceUserTotal", params) };

export const findProvinceUserTotalList = (params) => { return req("get", "/api/provinceUserTotal/findProvinceUserTotalList", params) };

export const modifyProvinceUserTotal = (params) => { return req("post", "/api/provinceUserTotal/modifyProvinceUserTotal", params) };

export const removeProvinceUserTotal = (params) => { return req("post", "/api/provinceUserTotal/removeProvinceUserTotal", params) };

export const findProvinceUserTotal = (params) => { return req("get", "/api/provinceUserTotal/findProvinceUserTotal", params) };

export const findDayMsgDetailByDepId = (params) => { return req("get", "/api/msg/findDayMsgDetailByDepId", params) };

export const msgContractTotal = (params) => { return req("get", "/api/msg/msgContractTotal", params) };

export const findMsgContractList = (params) => { return req("get", "/api/msgContract/findMsgContractList", params) };

export const addMsgContract = (params) => { return req("post", "/api/msgContract/addMsgContract", params) };

export const modifyMsgContract = (params) => { return req("post", "/api/msgContract/modifyMsgContract", params) };

export const deleteMsgContract = (params) => { return req("post", "/api/msgContract/deleteMsgContract", params) };

export const findMsgDetailGroupTotal = (params) => { return req("get", "/api/msg/findMsgDetailGroupTotal", params) };

export const getMsgDetailList = (params) => { return req("get", "/api/msg/getMsgDetailList", params) };



// WEBPACK FOOTER //
// ./src/api/summaryMG.js